"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Control = _interopRequireDefault(require("./Control.js"));

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _css = require("../css.js");

var _easing = require("../easing.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/control/Rotate
 */


/**
 * @typedef {Object} Options
 * @property {string} [className='ol-rotate'] CSS class name.
 * @property {string|HTMLElement} [label='⇧'] Text label to use for the rotate button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Reset rotation'] Text label to use for the rotate tip.
 * @property {string} [compassClassName='ol-compass'] CSS class name for the compass.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {boolean} [autoHide=true] Hide the control when rotation is 0.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control should
 * be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {function():void} [resetNorth] Function called when the control is clicked.
 * This will override the default `resetNorth`.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */

/**
 * @classdesc
 * A button control to reset rotation to 0.
 * To style this control use css selector `.ol-rotate`. A `.ol-hidden` css
 * selector is added to the button when the rotation is 0.
 *
 * @api
 */
var Rotate =
/** @class */
function (_super) {
  __extends(Rotate, _super);
  /**
   * @param {Options} [opt_options] Rotate options.
   */


  function Rotate(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    _this = _super.call(this, {
      element: document.createElement('div'),
      render: options.render,
      target: options.target
    }) || this;
    var className = options.className !== undefined ? options.className : 'ol-rotate';
    var label = options.label !== undefined ? options.label : "\u21E7";
    var compassClassName = options.compassClassName !== undefined ? options.compassClassName : 'ol-compass';
    /**
     * @type {HTMLElement}
     * @private
     */

    _this.label_ = null;

    if (typeof label === 'string') {
      _this.label_ = document.createElement('span');
      _this.label_.className = compassClassName;
      _this.label_.textContent = label;
    } else {
      _this.label_ = label;

      _this.label_.classList.add(compassClassName);
    }

    var tipLabel = options.tipLabel ? options.tipLabel : 'Reset rotation';
    var button = document.createElement('button');
    button.className = className + '-reset';
    button.setAttribute('type', 'button');
    button.title = tipLabel;
    button.appendChild(_this.label_);
    button.addEventListener(_EventType["default"].CLICK, _this.handleClick_.bind(_this), false);
    var cssClasses = className + ' ' + _css.CLASS_UNSELECTABLE + ' ' + _css.CLASS_CONTROL;
    var element = _this.element;
    element.className = cssClasses;
    element.appendChild(button);
    _this.callResetNorth_ = options.resetNorth ? options.resetNorth : undefined;
    /**
     * @type {number}
     * @private
     */

    _this.duration_ = options.duration !== undefined ? options.duration : 250;
    /**
     * @type {boolean}
     * @private
     */

    _this.autoHide_ = options.autoHide !== undefined ? options.autoHide : true;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.rotation_ = undefined;

    if (_this.autoHide_) {
      _this.element.classList.add(_css.CLASS_HIDDEN);
    }

    return _this;
  }
  /**
   * @param {MouseEvent} event The event to handle
   * @private
   */


  Rotate.prototype.handleClick_ = function (event) {
    event.preventDefault();

    if (this.callResetNorth_ !== undefined) {
      this.callResetNorth_();
    } else {
      this.resetNorth_();
    }
  };
  /**
   * @private
   */


  Rotate.prototype.resetNorth_ = function () {
    var map = this.getMap();
    var view = map.getView();

    if (!view) {
      // the map does not have a view, so we can't act
      // upon it
      return;
    }

    var rotation = view.getRotation();

    if (rotation !== undefined) {
      if (this.duration_ > 0 && rotation % (2 * Math.PI) !== 0) {
        view.animate({
          rotation: 0,
          duration: this.duration_,
          easing: _easing.easeOut
        });
      } else {
        view.setRotation(0);
      }
    }
  };
  /**
   * Update the rotate control element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */


  Rotate.prototype.render = function (mapEvent) {
    var frameState = mapEvent.frameState;

    if (!frameState) {
      return;
    }

    var rotation = frameState.viewState.rotation;

    if (rotation != this.rotation_) {
      var transform = 'rotate(' + rotation + 'rad)';

      if (this.autoHide_) {
        var contains = this.element.classList.contains(_css.CLASS_HIDDEN);

        if (!contains && rotation === 0) {
          this.element.classList.add(_css.CLASS_HIDDEN);
        } else if (contains && rotation !== 0) {
          this.element.classList.remove(_css.CLASS_HIDDEN);
        }
      }

      this.label_.style.transform = transform;
    }

    this.rotation_ = rotation;
  };

  return Rotate;
}(_Control["default"]);

var _default = Rotate;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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